import { Component, OnInit } from '@angular/core';
import { LoadingService } from '../services/loading.service';
import { DataService } from '../services/data.service';
import $ from "jquery";
import { Router } from '../../../node_modules/@angular/router';

@Component({
  selector: 'app-homescreen',
  templateUrl: './homescreen.component.html',
  styleUrls: ['./homescreen.component.scss']
})
export class HomescreenComponent implements OnInit {

  constructor(
    public loadingSvc: LoadingService,
    public dataSvc: DataService,
    public router: Router
  ) { }

  ngOnInit() {
    // this.loadingSvc.changeLoading(false);
    this.dataSvc.resetFilters();
    this.dataSvc.pageUrl = "home";
  }

  filterChanged(key: string) {
    clearTimeout(this.dataSvc.syncTimeout);
    for (let item of this.dataSvc.filterData[key]) {
      var sd = this.dataSvc.searchData[key].find(x => x.name == item.name);
      sd.value = true;
    }
    this.dataSvc.syncTimeout = setTimeout(() => {
      this.dataSvc.syncFilters();
    }, 500);
  }

  goToCounsellors() {
    this.dataSvc.cleanFilters("counsellor");
    this.loadingSvc.changeLoading("homescreen.goToCounsellors", true);

    this.dataSvc.syncTimeout = setTimeout(() => {
      this.dataSvc.syncFilters();
      this.dataSvc.syncTimeout = setTimeout(() => {
        this.dataSvc.syncFilters();
      }, 500);
      this.dataSvc.filterData.JobRoleTypeDescription = [{ "name": "[[[Counsellor]]]", "value": true }];
      this.dataSvc.applySearch().then(result => {
        if (!result) return;

        this.dataSvc.isAgent = false;
        this.dataSvc.topLevelFilter = JSON.parse(JSON.stringify(this.dataSvc.filterData));
        this.dataSvc.hasChosen = true;
        this.loadingSvc.changeLoading("homescreen.goToCounsellors", false);
        this.router.navigateByUrl("/agents");
      });
    }, 200);

  }

  goToAgents() {
    this.dataSvc.cleanFilters("agent");

    this.loadingSvc.changeLoading("homescreen.goToAgents", true);

    this.dataSvc.syncTimeout = setTimeout(() => {
      this.dataSvc.syncFilters();
      this.dataSvc.syncTimeout = setTimeout(() => {
        this.dataSvc.syncFilters();
      }, 500);
      this.dataSvc.filterData.JobRoleTypeDescription = [{ "name": "[[[Agent]]]", "value": true }];
      this.dataSvc.applySearch().then(result => {
        if (!result) return;

        this.dataSvc.isAgent = true;
        this.dataSvc.topLevelFilter = JSON.parse(JSON.stringify(this.dataSvc.filterData));
        this.dataSvc.hasChosen = true;
        this.loadingSvc.changeLoading("homescreen.goToAgents", false);
        this.router.navigateByUrl("/agents");

      });
    }, 200);
  }
}